import { connect } from 'react-redux';
import withImmutablePropsToJS from 'with-immutable-props-to-js';

import { Instances } from '../../../constants';
import { ContactsFormNameType, ContactsType } from '../../../interface';
import { IStateType } from '../../../store/models/root.interface';
import {
	makeSelectObject,
	removeObject,
	requestLocalChangeObjectField,
	localCreateInitialObject,
} from '../../../store/Object';
import { closeSideBar } from '../../../store/sidebar';

import ContactsForm, {
	MapStateType,
	DispatchPropsType,
} from '../organisms/contacts/ContactForm';

const mapStateToProps = (state: IStateType) => ({
	contacts: makeSelectObject(Instances.directoryContacts)(state) || {},
});

const mapDispatchToProps = {
	onChange: (fields: { name: ContactsFormNameType; value: any }) =>
		requestLocalChangeObjectField(Instances.directoryContacts, fields),
	onClose: () => closeSideBar([removeObject(Instances.directoryContacts)]),
	loadInitObject: (contacts: Partial<ContactsType>) =>
		localCreateInitialObject(Instances.directoryContacts, contacts),
};

export default connect<MapStateType, DispatchPropsType, unknown, IStateType>(
	mapStateToProps,
	mapDispatchToProps
)(withImmutablePropsToJS(ContactsForm));
